// extracted by mini-css-extract-plugin
export default {"root":"IconRoute_root__2dgJ+"};